import type { PlaylistItem } from '@/shared/models/playlist.model';
import { compararPorMaisPedida } from './ordenarRepertorio';

/**
 * Junta o snapshot de `listarPlaylistItens` com o que o CDC aplicou durante o fetch.
 *
 * - Snapshot é a fonte dos IDs ativos no servidor no momento da query.
 * - IDs que o CDC removeu durante o fetch não voltam, mesmo se ainda estiverem no snapshot.
 * - INSERTs que o CDC aplicou *durante esta janela de fetch* e o snapshot não viu entram no
 *   resultado — a única exceção à autoridade do servidor.
 */
export function mesclarItensAposFetch(
  prev: readonly PlaylistItem[],
  snapshot: readonly PlaylistItem[],
  idsRemovidosDuranteFetch: ReadonlySet<string> = new Set(),
  idsInseridosDuranteFetch: ReadonlySet<string> = new Set(),
): PlaylistItem[] {
  const snapshotIds = new Set(snapshot.map(item => item.id));
  const resultado: PlaylistItem[] = [];

  for (const item of snapshot) {
    if (idsRemovidosDuranteFetch.has(item.id)) continue;
    resultado.push(item);
  }

  for (const item of prev) {
    if (snapshotIds.has(item.id)) continue;
    if (idsRemovidosDuranteFetch.has(item.id)) continue;
    if (!idsInseridosDuranteFetch.has(item.id)) continue;
    resultado.push(item);
  }

  return resultado.sort(compararPorMaisPedida);
}
